<style lang="stylus">
    .splitTableCell-mask
        modal-mask()
        .splitTableCell-modal
            width 378px
            height 200px
            .splitTableCell-container
                padding 15px 20px
                .splitTableCell-line
                    margin-bottom 10px
                    height 30px
                    line-height 30px
                    span
                        vertical-align middle
                    .splitTableCell-input
                        float right
</style>

<template>
    <div class="splitTableCell-mask">
        <Dialog class="splitTableCell-modal" :title="$t('splitTableCell.title')" :isShow="true" @close="closeModal">
            <div class="splitTableCell-container">
                <div class="splitTableCell-line">
                    <span>{{ $t("splitTableCell.rowNum") }}</span>
                    <InputNumber
                        class="splitTableCell-input"
                        @on-focus="editLocker('focus', 'lock')"
                        @on-blur="
                            editLocker('blur', 'lock', () => {
                                checkData(1);
                            })
                        "
                        @on-change="
                            editLocker('edit', 'lock', () => {
                                checkData(1);
                            })
                        "
                        :min="1"
                        :max="20"
                        v-model="splitRows"
                    ></InputNumber>
                </div>
                <div class="splitTableCell-line">
                    <span>{{ $t("splitTableCell.colNum") }}</span>
                    <InputNumber
                        class="splitTableCell-input"
                        @on-focus="editLocker('focus', 'lock')"
                        @on-blur="
                            editLocker('blur', 'lock', () => {
                                checkData(0);
                            })
                        "
                        @on-change="
                            editLocker('edit', 'lock', () => {
                                checkData(0);
                            })
                        "
                        :min="1"
                        :max="20"
                        v-model="splitColumns"
                    ></InputNumber>
                </div>
            </div>

            <div class="dialog-btnbox-normal" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                <div class="dialog-btn-ok" @click="confirm()">{{ $t("splitTableCell.confirm") }}</div>
                <div class="" @click="closeModal()">{{ $t("splitTableCell.cancel") }}</div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";

    @Component({
        components: {
            Dialog,
        },
    })
    export default class splitTableCell extends Vue {
        splitRows: number = 1;
        splitColumns: number = 2;
        timer: number = 0;
        lock: boolean = false;
        editLocker(type, lock, fn?) {
            let map = new Map([
                [
                    "focus",
                    () => {
                        this[lock] = true;
                    },
                ],
                [
                    "blur",
                    () => {
                        this[lock] = false;
                        fn();
                    },
                ],
                [
                    "edit",
                    () => {
                        if (!this[lock]) {
                            fn();
                        }
                    },
                ],
            ]);
            map.get(type)();
        }
        checkData(type) {
            this.lock = false;
            if (!!type) {
                this.splitRows = this.splitRows < 1 ? 1 : Math.round(this.splitRows) > 20 ? 20 : Math.round(this.splitRows);
            } else {
                this.splitColumns = this.splitColumns < 1 ? 1 : Math.round(this.splitColumns) > 20 ? 20 : Math.round(this.splitColumns);
            }
        }
        confirm() {
            window["_view"].tableSplitCell(this.splitRows, this.splitColumns);
            this.splitRows = 1;
            this.splitColumns = 2;
            this.closeModal();
        }
        closeModal() {
            this.splitRows = 1;
            this.splitColumns = 2;
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "splitTableCell": {
      "title": "拆分单元格",
      "rowNum": "行数",
      "colNum": "列数",
      "confirm": "确定",
      "cancel": "取消"
    }
  },
  "en": {
    "splitTableCell": {
      "title": "Split Cells",
      "rowNum": "Row Numbers",
      "colNum": "Column Numbers",
      "confirm": "OK",
      "cancel": "Cancel"
    }
  },
  "fr": {
    "splitTableCell": {
      "title": "Cellules divisés",
      "rowNum": "Numéros de ligne",
      "colNum": "Numéros de colonne",
      "confirm": "OK",
      "cancel": "Annuler"
    }
  },
  "de": {
    "splitTableCell": {
      "title": "Zeile unterteilen",
      "rowNum": "Zeilennummer  ",
      "colNum": "Spaltennummer",
      "confirm": "Sichern",
      "cancel": "Abbrechen"
    }
  },
  "jp": {
    "splitTableCell": {
      "title": "セルの分割",
      "rowNum": "行数",
      "colNum": "列数",
      "confirm": "OK",
      "cancel": "キャンセル"
    }
  },
  "es": {
    "splitTableCell": {
      "title": "Células divididas",
      "rowNum": "Números de fila",
      "colNum": "Números de columna",
      "confirm": "Aceptar",
      "cancel": "Cancelar"
    }
  },
  "pt": {
    "splitTableCell": {
      "title": "Dividir Células",
      "rowNum": "Números de Linha",
      "colNum": "Números de Coluna",
      "confirm": "OK",
      "cancel": "Cancelar"
    }
  },
  "it": {
    "splitTableCell": {
      "title": "Dividi Celle",
      "rowNum": "Numeri Righe",
      "colNum": "Numeri Colonne",
      "confirm": "OK",
      "cancel": "Annulla"
    }
  },
  "tw": {
    "splitTableCell": {
      "title": "拆分單元格",
      "rowNum": "行數",
      "colNum": "列數",
      "confirm": "確定",
      "cancel": "取消"
    }
  },
  "kr": {
    "splitTableCell": {
      "title": "셀 분할",
      "rowNum": "행수",
      "colNum": "열수",
      "confirm": "확인",
      "cancel": "취소"
    }
  }
}
</i18n>
